/* eslint-disable */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getConfigKey, prepareHeaders } from 'utility/Api'
import { Profile } from 'types'
import apiConfigs from 'Api/api-config'

const baseUrl = apiConfigs[getConfigKey()].apiHost
const apiPath = apiConfigs[getConfigKey()].paths.digitalId

// Define a service using a base URL and expected endpoints
export const DigitalIdApi = createApi({
  reducerPath: 'digitalIdApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  endpoints: builder => ({
    getProfile: builder.query<Profile, void>({
      query: () => 'profile'
    }),
    getProfilePictureUrl: builder.query<string, void>({
      query: () => {
        return {
          url: 'picture',
          method: 'GET',
          responseHandler: async response => {
            return await response.blob() // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: Blob, meta, arg) => {
        return URL.createObjectURL(response)
      }
    }),
    searchPerson: builder.query<Array<{ id: string; name: string }>, string>({
      query: q => `search?q=${q}`,
      transformResponse: (response: Profile[]) => {
        return response.map(row => ({ id: row.mit_id, name: row.display_name }))
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProfileQuery, useGetProfilePictureUrlQuery, useSearchPersonQuery } = DigitalIdApi
/* eslint-enable */
